import { render, staticRenderFns } from "./AdvantagesObject.vue?vue&type=template&id=0cfa9eba&scoped=true&lang=pug&"
import script from "./AdvantagesObject.vue?vue&type=script&lang=js&"
export * from "./AdvantagesObject.vue?vue&type=script&lang=js&"
import style0 from "./AdvantagesObject.vue?vue&type=style&index=0&id=0cfa9eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa9eba",
  null
  
)

export default component.exports